import { calculatePackPricing, toNumber } from './packPricing';

export const findPurchasePreviewInventory = (rows, barcodeId, warehouseId) => {
  if (!barcodeId || barcodeId === '*') return null;
  return rows.filter(row => String(row.product_barcode_id) === String(barcodeId)
    && (!warehouseId || String(row.warehouse_id) === String(warehouseId)))
    .sort((a, b) => {
      const receivedAt = row => Date.parse(row.created_at || '') || 0;
      return receivedAt(b) - receivedAt(a) || Number(b.id) - Number(a.id);
    })[0] || null;
};

export const calculatePurchaseMarginPreview = ({ baseAmount, margin, factor, inventory }) => {
  const pricing = calculatePackPricing({ unitCost: baseAmount, marginPercent: margin, proportionFactor: factor });
  // Purchase verification persists unit_mrp on inventory; margin rules must never replace it.
  const savedMrp = toNumber(inventory?.unit_mrp ?? inventory?.unit_MRP);
  const mrp = savedMrp > 0 ? savedMrp : null;
  return {
    baseAmount,
    effectiveMargin: pricing.effectiveMarginPercent,
    mrp,
    dpriceBeforeRound: baseAmount > 0
      ? Number((baseAmount * (1 + margin * factor / 100)).toFixed(2)) : 0,
    dprice: pricing.dprice,
    effectiveDiscount: mrp === null ? null : (mrp - pricing.dprice) / mrp * 100,
    exceedsMrp: mrp !== null && pricing.dprice > mrp,
  };
};
